import React from 'react';

import { ReactComponent as Airtable } from './airtable.svg';
import { ReactComponent as Audio } from './audio.svg';

import { ReactComponent as Confluence } from './confluence.svg';

import { ReactComponent as Database } from './database.svg';
import { ReactComponent as Disc } from './disc.svg';

import { ReactComponent as Ebook } from './ebook.svg';
import { ReactComponent as Evernote } from './evernote.svg';
import { ReactComponent as Exe } from './exe.svg';

import { ReactComponent as Figma } from './figma.svg';
import { ReactComponent as File } from './file.svg';
import { ReactComponent as Folder } from './folder.svg';
import { ReactComponent as Font } from './font.svg';

import { ReactComponent as Github } from './github.svg';
import { ReactComponent as GithubPR } from './github_pr.svg';
import { ReactComponent as GithubIssue } from './github_issue.svg';

import { ReactComponent as GoogleExcel } from './google_excel.svg';
import { ReactComponent as GoogleForm } from './google_form.svg';
import { ReactComponent as GooglePowerpoint } from './google_powerpoint.svg';
import { ReactComponent as GoogleWord } from './google_word.svg';
import { ReactComponent as GoogleDrawing } from './google_drawing.svg';

import { ReactComponent as Hellosign } from './hellosign.svg';

import { ReactComponent as Illustrator } from './illustrator.svg';
import { ReactComponent as Image } from './image.svg';
import { ReactComponent as Indesign } from './indesign.svg';

import { ReactComponent as Keynote } from './keynote.svg';

import { ReactComponent as Miro } from './miro.svg';

import { ReactComponent as OfficeExcel } from './office_excel.svg';
import { ReactComponent as OfficePowerpoint } from './office_powerpoint.svg';
import { ReactComponent as OfficeWord } from './office_word.svg';
import { ReactComponent as Onenote } from './onenote.svg';

import { ReactComponent as Paper } from './paper.svg';
import { ReactComponent as Pdf } from './pdf.svg';
import { ReactComponent as Photoshop } from './photoshop.svg';
import { ReactComponent as Presentation } from './presentation.svg';

import { ReactComponent as Quip } from './quip.svg';

import { ReactComponent as Script } from './script.svg';
import { ReactComponent as Sketch } from './sketch.svg';
import { ReactComponent as System } from './system.svg';

import { ReactComponent as Text } from './text.svg';

import { ReactComponent as Url } from './url.svg';

import { ReactComponent as Video } from './video.svg';

import { ReactComponent as Word } from './word.svg';

import { ReactComponent as Zip } from './zip.svg';

import { ReactComponent as Zoom } from './zoom.svg';
import { ReactComponent as ZoomVideo } from './zoom_video.svg';
import { ReactComponent as ZoomAudio } from './zoom_audio.svg';

export function fileTypeImageByType(fileType, className) {
  const components = {
    airtable: Airtable,
    audio: Audio,

    confluence: Confluence,

    database: Database,
    disc: Disc,
    document: GoogleWord,
    dropbox_paper: Paper,

    ebook: Ebook,
    evernote: Evernote,
    exe: Exe,

    figma: Figma,
    file: File,
    folder: Folder,
    forms: GoogleForm,
    font: Font,

    github: Github,
    github_gist: Github,
    github_pr: GithubPR,
    github_issue: GithubIssue,

    google_excel: GoogleExcel,
    google_form: GoogleForm,
    google_powerpoint: GooglePowerpoint,
    google_presentation: GooglePowerpoint,
    google_word: GoogleWord,
    google_drawing: GoogleDrawing,

    hellosign: Hellosign,

    illustrator: Illustrator,
    image: Image,
    indesign: Indesign,
    index: File,

    keynote: Keynote,

    miro: Miro,

    notejoy: File,

    office_excel: OfficeExcel,
    office_powerpoint: OfficePowerpoint,
    office_word: OfficeWord,
    onenote: Onenote,

    paper: Paper,
    pdf: Pdf,
    photoshop: Photoshop,
    presentation: Presentation,

    quip: Quip,

    script: Script,
    sketch: Sketch,
    spreadsheets: GoogleExcel,
    system: System,

    text: Text,

    url: Url,

    video: Video,

    word: Word,

    zip: Zip,

    zoom: Zoom,
    zoom_audio: ZoomAudio,
    zoom_video: ZoomVideo,
  };

  let TagName = components[fileType];

  if (!TagName) {
    TagName = components['file'];
  }

  return <TagName className={className} />;
}
